import { ReactElement } from 'react';
import './icons.css';

export const InprogressSVG = (): ReactElement => (
  <svg
    className="sidebarIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.75 3C3.67893 3 2 4.67893 2 6.75V17.0786C2 19.1497 3.67894 20.8286 5.75 20.8286H17.8929C19.964 20.8286 21.6429 19.1497 21.6429 17.0786V6.75C21.6429 4.67893 19.964 3 17.8929 3H5.75ZM3.5 6.75C3.5 5.50736 4.50736 4.5 5.75 4.5H17.8929C19.1355 4.5 20.1429 5.50736 20.1429 6.75V17.0786C20.1429 18.3213 19.1355 19.3286 17.8929 19.3286H5.75C4.50736 19.3286 3.5 18.3213 3.5 17.0786V6.75ZM14.0974 8.80702C13.9619 8.58111 13.7178 8.44289 13.4543 8.44289C13.1909 8.44289 12.9467 8.58111 12.8112 8.80702L10.1886 13.178L9.19886 11.5285C9.06332 11.3025 8.81919 11.1643 8.55574 11.1643H6.37859C5.96438 11.1643 5.62859 11.5001 5.62859 11.9143C5.62859 12.3285 5.96438 12.6643 6.37859 12.6643H8.1311L9.54548 15.0216C9.68102 15.2475 9.92515 15.3858 10.1886 15.3858C10.452 15.3858 10.6962 15.2475 10.8317 15.0216L13.4543 10.6506L14.4441 12.3002C14.5796 12.5261 14.8237 12.6643 15.0872 12.6643H17.2643C17.6785 12.6643 18.0143 12.3285 18.0143 11.9143C18.0143 11.5001 17.6785 11.1643 17.2643 11.1643H15.5118L14.0974 8.80702Z"
    />
  </svg>
);
